<template>
	<div>
		<el-container >
			<el-aside width="250px">
				<DeptTree @getTreeData="deptTreeNodeClick"/>
			</el-aside>

			<el-container>
				<el-header >
					<el-form :inline="true" >
						<el-form-item>
							<el-input
									v-model="searchForm.code"
									placeholder="人员编号"
									clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-input
									v-model="searchForm.name"
									placeholder="姓名"
									clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-select v-model="collectValue" placeholder="请选择">
								<el-option
								v-for="item in collectOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item>
							<el-button @click="getPersonList">搜索</el-button>
						</el-form-item>

						<!-- <el-form-item>
							<el-button type="primary" @click="dialogVisible = true">新增</el-button>
						</el-form-item>

						<el-form-item>
							<el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
								<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
							</el-popconfirm>
						</el-form-item> -->
					</el-form>
				</el-header>

				<el-main>
					<el-table
							ref="multipleTable"
							:data="tableData"
							tooltip-effect="dark"
							style="width: 100%; margin-top: -20px;"
							:height="tableHeight"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '2px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe
							@selection-change="handlePersonChange"
							@row-click="handlePersonChange">

						<!-- <el-table-column
								type="selection"
								width="55">
						</el-table-column> -->

						<el-table-column
								prop="personNo"
								label="人员编号"
								show-overflow-tooltip
								width="200">
						</el-table-column>

						<el-table-column
								prop="personName"
								label="姓名"
								show-overflow-tooltip
								width="200">
						</el-table-column>

						<el-table-column
								prop="personSex"
								label="性别"
								width="80">
								<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.personSex === 1" type="success">男</el-tag>
								<el-tag size="small" v-else-if="scope.row.personSex === 0" type="danger">女</el-tag>
								<el-tag size="small" v-else type="danger">未知</el-tag>
							</template>
						</el-table-column>

						<el-table-column
								prop="identityName"
								label="身份"
								show-overflow-tooltip
								width="100">
						</el-table-column>

						<el-table-column
								prop="fullName"
								label="部门"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								label="是否已采集"
								show-overflow-tooltip
								width="120">
								<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.spareField1 === '1'" type="success">是</el-tag>
								<el-tag size="small" v-else type="danger">否</el-tag>
							</template>
						</el-table-column>

						<el-table-column
								prop="icon"
								label="操作"
								width="120">

							<template slot-scope="scope">

								<el-button type="text" @click="editHandle(scope.row)">采集指纹</el-button>

							</template>
						</el-table-column>

					</el-table>

					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:page-sizes="[10, 20, 50, 100]"
							:current-page="current"
							:page-size="size"
							:total="total"
							style="margin-top: 5px;">
					</el-pagination>
				</el-main>
				<el-footer>
					<el-table
							ref="fingerTable"
							:data="fingerData"
							tooltip-effect="dark"
							style="width: 100%; margin-top: 0px;"
							:height="200"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '2px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe
							@selection-change="handleSelectionChange">

						<!-- <el-table-column
								type="selection"
								width="55">
						</el-table-column> -->

						<el-table-column
								prop="personNo"
								label="人员编号"
								show-overflow-tooltip
								width="130">
						</el-table-column>

						<el-table-column
								prop="personName"
								label="姓名"
								show-overflow-tooltip
								width="120">
						</el-table-column>

						<el-table-column
								prop="personSex"
								label="性别"
								width="80">
								<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.personSex === 1" type="success">男</el-tag>
								<el-tag size="small" v-else-if="scope.row.personSex === 0" type="danger">女</el-tag>
								<el-tag size="small" v-else type="danger">未知</el-tag>
							</template>
						</el-table-column>

						<el-table-column
								prop="identityName"
								label="身份"
								show-overflow-tooltip
								width="100">
						</el-table-column>

						<el-table-column
								prop="deptFullName"
								label="部门"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="fingerNum"
								label="指纹编号"
								show-overflow-tooltip
								width="100">
						</el-table-column>

						<el-table-column
								prop="remark"
								label="说明"
								show-overflow-tooltip
								width="100">
						</el-table-column>
						
						<el-table-column
								prop="createTime"
								label="采集时间"
								show-overflow-tooltip
								width="180">
						</el-table-column>

						<el-table-column
								prop="userName"
								label="采集人"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="icon"
								label="操作"
								width="120">

							<template slot-scope="scope">

								<!-- <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
								
								<el-divider direction="vertical"></el-divider> -->

								 <template>
									<el-popconfirm title="确定删除该指纹信息吗？" @confirm="delHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template>

							</template>
						</el-table-column>

					</el-table>
				</el-footer>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
				:title="collectPersonInfo"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-container>
					<el-aside width="400px">
						<el-form-item label="指纹编号" prop="fingerNum" label-width="100px">
							<el-select v-model="editForm.fingerNum" placeholder="请选择">
								<el-option
								v-for="item in fingerNoOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>	

						<el-form-item label="说明" prop="remark" label-width="100px">
							<el-input v-model="editForm.remark" autocomplete="off"></el-input>
						</el-form-item>
						
						<el-form-item label-width="60px">
							<el-image 
								style="width: 200px; height: 200px"
								:src="this.publicPath + '/finger.jpg'">
							</el-image>
						</el-form-item>	
						
					</el-aside>
					
				</el-container>

				<el-form-item>
					<el-button type="success" :disabled="isCollect" @click="startCollectFinger()">开始采集</el-button>
					<!-- <el-button type="success" :disabled="!isCollect" @click="sendMsgToWs()">发送信息</el-button> -->
					<el-button type="info" :disabled="!isCollect" @click="stopCollectFinger()">停止采集</el-button>
				</el-form-item>
				<el-form-item>
					<!-- <h3 type="warning">{{collectTitle}}</h3> -->
					<span style="color: red !important;font-size:18px;">{{ collectTitle }}</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
    import DeptTree from "./DeptTree.vue"
	export default {
		name: "FingerList",
		components:{DeptTree},
		data() {
			return {
				publicPath: process.env.BASE_URL,
				searchForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {

				},

				tableData: [],
				fingerData: [],

				//人员信息表格选择行的人员Id
				selectedPersonId: '',
				//采集指纹的人员Id
				collectPersonId: '',
				//采集指纹的人员信息
				collectPersonInfo: '',
				selectedIdentityId:'',
				identityList:[],

				editFormRules: {
					fingerNum: [
						{required: true, message: '请选择指纹编号', trigger: 'blur'}
					]
				},

				multipleSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'personName'
				},
				permTreeData: [],
				treeSelectDeptId: 0,
				collectOptions: [{
					value: '0',
					label: '全部'
					}, {
					value: '1',
					label: '已采集'
					}, {
					value: '2',
					label: '未采集'
					}],
				
				collectValue: '1',
				
				fingerNoOptions: [{
					value: '1',
					label: '第1个指纹'
					}, {
					value: '2',
					label: '第2个指纹'
					}, {
					value: '3',
					label: '第3个指纹'
					}],
				// 采集指纹提示信息
				collectTitle: '',
				isCollect: false,
				timer: "",
				timerValue: 30,
				// 指纹WebSocket对象
				fingerWs: null,
				// 指纹WebSocket地址
				fingerUrl: 'ws://localhost:9618',
				// 指纹特征值
				fingerVal: '',
				// 指纹采集状态标志，0-初始；1-检测设备成功
				fingerStatusFlag: 0,
				//指纹采集序号
				fingerIndex: 1,
				//检测手指
				checkFinger: false,
				//允许采集指纹特征值
				allowGetFinger: false,
				//成功获取指纹序号
				getFingerFlag: 0,
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 430: 350
			}
		},
		created() {
			this.getPersonList()

			this.$axios.get('/base/finger/list').then(res => {
				this.permTreeData = res.data.data
			})
		},
		beforeDestroy() {
			clearInterval(this.timer);
			// 销毁监听
			this.fingerWs.close
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},
			handlePersonChange(row) {
				this.selectedPersonId=row.id
				this.getFingerList();
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getPersonList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getPersonList()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},
			deptSelectNodeClick(deptdata) {
				this.$set(this.editForm, "deptId", deptdata.id);
				this.$set(this.editForm, "fullName", deptdata.fullName);
				// console.log(deptdata);
			},
			deptTreeNodeClick(deptdata) {
				this.treeSelectDeptId = deptdata.id;
				this.getPersonList();
			},

			getPersonList() {
				this.$axios.get("/base/finger/personlist", {
					params: {
						code: this.searchForm.code,
						name: this.searchForm.name,
						deptId: this.treeSelectDeptId,
						collectFlag: this.collectValue,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			getFingerList() {
				this.$axios.get("/base/finger/list", {
					params: {
						personId: this.selectedPersonId,
					}
				}).then(res => {
					this.fingerData = res.data.data.records
				})
			},
			startCollectFinger() {
				// 开始采集指纹
				this.timerValue=30;
				this.fingerVal='';
				this.isCollect=true;
				this.fingerStatusFlag=0;
				this.fingerIndex=1;
				this.checkFinger=false;
				this.allowGetFinger=false;
				this.getFingerFlag=0;
				//连接指纹采集设备
				this.ws_init();
				//检测指纹采集设备
				//this.ws_send({"reqcode":"FM_Init"});
				this.collectTitle='请把手指按压到指纹采集设备上';
				// 注意: 第一个参数为方法名的时候不要加括号;
				this.timer = setInterval(this.collectFinger, 1000); 
			},
			stopCollectFinger() {
				// 停止采集指纹
				this.isCollect=false;
				this.fingerStatusFlag=0;
				this.fingerIndex=1;
				//关闭指纹采集设备
				this.ws_send({"reqcode":"FM_Deinit"});
				this.collectTitle='';
				
				clearInterval(this.timer);
			},
			sendMsgToWs() {
				//检测指纹采集设备
				this.ws_send({"reqcode":"FM_Init"});
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.editForm);
						this.$axios.post('/base/finger/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
									onClose:() => {
										this.getPersonList()
									}
								});

								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(row) {

				this.collectPersonId=row.id
				this.editForm.personId=row.id
				this.collectPersonInfo=row.personNo + '(' + row.personName + ')指纹采集'
				//resetForm('editForm')
				this.dialogVisible = true


				// this.$axios.get('/base/finger/info/' + id).then(res => {
				// 	this.editForm = res.data.data

				// 	this.dialogVisible = true
				// })
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/base/finger/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getPersonList()
						}
					});
				})
			},
			collectFinger(){
				
				if (this.fingerStatusFlag == 0) {
					//检测指纹采集设备
					this.ws_send({"reqcode":"FM_Init"});
					return;
				} else {
					if (this.getFingerFlag < 3) {
						//还没采集够3次
						if (this.checkFinger == false) {
							//检测手指
							this.ws_send({"reqcode":"FM_DetectFinger"});
						} else {
							if (this.allowGetFinger) {
								//获取手指特征值
								this.ws_send({"reqcode":"FM_Extract","index":this.fingerIndex});
							}
						}
					} else {
						//采集够3次后，合成指纹模板
						this.ws_send({"reqcode":"FM_Enroll"});
					}
				}

				if (this.timerValue > 0) {
					this.timerValue=this.timerValue-1;
				} else {
					this.stopCollectFinger();
				}
				
			},
			ws_init() {
				if(typeof(WebSocket) === "undefined"){
					alert("您的浏览器不支持socket")
				}else{
					if (this.fingerWs != null) {
						return;
					}
					// 实例化socket
					this.fingerWs = new WebSocket(this.fingerUrl)
					// 监听socket连接
					this.fingerWs.onopen = this.ws_open
					// 监听socket错误信息
					this.fingerWs.onerror = this.ws_error
					// 监听socket消息
					this.fingerWs.onmessage = this.ws_getMessage
					// 监听socket关闭
					this.fingerWs.onclose = this.ws_close
				}
			},
			ws_open() {
				console.log("WebSocket连接成功")
			},
			ws_error() {
				console.log("WebSocket连接错误")
			},
			ws_getMessage(msg) {
				var	s = msg.data.toString();
            	var obj = JSON.parse(s);
				console.log("WebSocket收到" + s)

				// 处理返回的结果标志
				this.handleWsResult(obj.result);

				if (obj.repcode === 'FM_Deinit') {
					return;
				}

				if (obj.repcode === 'FM_Init' && obj.result === '0') {
					//检测设备
					this.fingerStatusFlag=1;
					return;
				}

				if (this.fingerStatusFlag == 0) {
					//如果通信失败，则停止采集
					this.stopCollectFinger();
					return;
				}

				if (obj.repcode === 'FM_DetectFinger') {
					//检测手指
				   if (obj.result === '1') {
						//检测手指成功
						if (this.getFingerFlag < this.fingerIndex) {
							this.checkFinger=true;
							this.allowGetFinger=true;
						} else {
							this.checkFinger=false;
							this.allowGetFinger=false;
						}
						
					} else {
						//检测手指失败
						this.fingerIndex=this.getFingerFlag+1;
					}
					return;
				}

				if (obj.repcode === 'FM_Extract' && obj.result === '0') {
					//采集指纹特征值成功
					this.getFingerFlag=this.getFingerFlag+1;
					this.checkFinger=false;
					this.allowGetFinger=false;
					if (this.getFingerFlag < 3) {
						this.collectTitle='第[ '+ this.getFingerFlag + ']次指纹采集成功，请拿开手指再放手指';
					} else {
						this.collectTitle='第[ '+ this.getFingerFlag + ']次指纹采集成功，请稍等......';
					}
					
					return;
				}

				if (obj.repcode === 'FM_Enroll' && obj.result === '0') {
					//合成指纹模板成功
					// this.fingerVal=obj.template;
					this.editForm.fingerVal=obj.template;
					//停止采集指纹
					this.stopCollectFinger();
					this.collectTitle='指纹录入成功，请按"确定"保存指纹';
				}
			},
			ws_send(params) {
				this.fingerWs.send(JSON.stringify(params))
			},
			ws_close() {
				console.log("WebSocket已经关闭")
			},

			handleWsResult(iret){
				if(iret === '-1')
				{
					this.collectTitle='参数错误';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-2')
				{
					this.collectTitle='内存分配失败，没有分配到足够的内存';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-3')
				{
					this.collectTitle='功能未实现';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-4')
				{
					this.collectTitle='设备不存在';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-7')
				{
					//this.collectTitle='提取特征失败或合成模板失败';
				}
				else if(iret === '-5')
				{
					this.collectTitle='设备未初始化';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-6')
				{
					this.collectTitle='非法错误号';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-9')
				{
					this.collectTitle='其它错误';
					this.fingerStatusFlag=0;
				}
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 96%;
	}
</style>